import { render } from "./ViewDay.vue?vue&type=template&id=1a8df279"
import script from "./ViewDay.vue?vue&type=script&lang=js"
export * from "./ViewDay.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__